import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../i18n/i18n";

export default function EmptyStateMessage() {
    const { t, localizePath } = useI18n();
    return (
        <div className="emptyStateCard">
            <div className="emptyStateIcon" aria-hidden="true">🏋️‍♂️</div>
            <p className="emptyStateTitle">{t("home.emptyStateTitle")}</p>
            <div className="emptyStateActions">
                <Link
                    to={localizePath("/plan-workout")}
                    className="appButton homeActionButton homeActionButton--planner"
                    aria-label={t("home.planWorkout")}
                >
                    <span className="homeActionButtonSymbol" aria-hidden="true">🪄</span>
                    <span>{t("home.planWorkout")}</span>
                </Link>
                <Link
                    to={localizePath("/SelectExercise")}
                    className="appButton homeActionButton homeActionButton--secondary"
                    aria-label={t("home.addExercise")}
                >
                    <span>{t("home.addExercise")}</span>
                    <span className="homeActionButtonSymbol" aria-hidden="true">+</span>
                </Link>
            </div>
        </div>
    );
}
